import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { cubicar } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionNuevoCubicajeView } from '../components/OperacionNuevoCubicajeView'

export const OperacionNuevoCubicaje = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionNuevoCubicajeView
        silo={silo}
        aceptar={async ({ metrosDeVacio, ph }) => {
          try {
            await cubicar(silo, metrosDeVacio, ph)
            closeDialog()
            enqueueSnackbar('Cubicaje correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Cubicaje incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('CUBICAJE_SILO')
        }, [closeDialog])}
      />
    )
  })
)
